module.exports = __webpack_public_path__ + "static/team2-82c97250a9b31491236f09f1ec3fdf36.jpg";